import { ETripTaskType } from 'types/trips';

export const LOADING_TYPES: ETripTaskType[] = [
  ETripTaskType.loading,
  ETripTaskType.loading_wh,
  ETripTaskType.reloading_to,
];

export const SIMILAR_TASK_TYPE_GROUPS: ETripTaskType[][] = [
  [ETripTaskType.unloading, ETripTaskType.unloading_wh, ETripTaskType.reloading_from],
  [ETripTaskType.customs],
];

export const NON_EDITABLE_TASK_TYPES: ETripTaskType[] = [ETripTaskType.trailer_swap, ETripTaskType.return_asset];
